<template>
  <app-dialog color="blueSecondary">
    <template v-slot:dialogTitle>
      <UserCircleIcn
        fill-rule="evenodd"
        class="ml-5 mr-1 lightblue-icon-user" 
        width="20px"
        height="20px"
      ></UserCircleIcn>
      <span class="text-blueSecondary text-lg font-bold">プロフィール</span>
    </template>

    <template v-slot:dialogContent>
      <profile-form-navigation color="blueSecondry" class="mr-8 pt-4" @tabIndex="changeTab">
        <template v-slot:tabContent>
          <ProfileForm v-model:oldPass="oldPass" v-model:newPass="newPass" v-model:confirmPass="confirmPass"/>
        </template>
      </profile-form-navigation>
    </template>

    <template v-slot:dialogFooterActions>
      <user-circle-icn
        width="40px"
        height="40px"
        class="ml-1"
      ></user-circle-icn>

      <span
        class="scrollbar text-white ml-1 leading-tight"
        style="width:120px; overflow-x:scroll; white-space:nowrap;"
      >
        {{ currentUser.name }}
        <br />
        {{ dayjs(currentUser.updated_at).format('YYYY/M/D') }}登録
      </span>
      <ProfileRequestFooter :docType="tabIndex" @submitType="clickSubmit"/>
    </template>
  </app-dialog>
</template>
<script>
import { ref } from 'vue'
import { useCurrentUser } from '@/services/useCurrentUser'

import AppDialog from '@/components/ui/AppDialog'

import ProfileFormNavigation from '@/components/layout/user/ProfileFormNavigation'
import ProfileForm from '@/components/layout/user/ProfileForm'
import ProfileRequestFooter from '@/components/layout/user/ProfileRequestFooter'

import UserCircleIcn from '@/assets/icons/user-circle.svg?inline'
import { useAuth } from '@/services/useAuth'
export default {
  name: 'ProfileDialog',

  components: {
    AppDialog,
    UserCircleIcn,
    ProfileFormNavigation,
    ProfileForm,
    ProfileRequestFooter,
  },

  setup() {

    const { currentUser } = useCurrentUser()

    const { changePassword } = useAuth()

    const oldPass = ref("aaa")
    const newPass = ref("bbb")
    const confirmPass = ref("ccc")

    let tabIndex = ref(0)

    const changeTab = (i) => {
      tabIndex.value = i
    }

    const clickSubmit = (val) => {
      if(tabIndex.value === 2){
        changePassword({
        'current': oldPass.value,
        'new': newPass.value,
      })
        console.log(val)
      }
    }

    return {
      changeTab,
      clickSubmit,
      tabIndex,
      currentUser,
      oldPass,
      newPass,
      confirmPass
    }
  },
}
</script>
<style lang="scss" scoped>
.scrollbar::-webkit-scrollbar {
  display: none;
}
</style>
